import { render, staticRenderFns } from "./ShoplicenseField.vue?vue&type=template&id=3ecd0e62&scoped=true"
import script from "./ShoplicenseField.vue?vue&type=script&lang=ts"
export * from "./ShoplicenseField.vue?vue&type=script&lang=ts"
import style0 from "./ShoplicenseField.vue?vue&type=style&index=0&id=3ecd0e62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecd0e62",
  null
  
)

export default component.exports